import React, { useState } from "react";
import { PLANS } from "../../constants";
import {
  Accordion,
  Button,
  Card,
  Col,
  Container,
  Nav,
  Navbar,
  Row,
} from "react-bootstrap";

import { PieChart, Sliders, Smartphone, Users } from "react-feather";

import screenshotAds from "../../assets/img/screenshots/ads.png";

const Navigation = () => (
  <Navbar expand="md" className="landing-navbar">
    <Container>
      <Navbar.Brand className="landing-brand" href="/">
        NoviOglasi.com{" "}
      </Navbar.Brand>
      <Nav className="ms-auto" navbar>
        <Nav.Item>
          <Nav.Link href="#features" className="text-lg px-lg-3">
            Predstavitev
          </Nav.Link>
        </Nav.Item>
        <Nav.Item className="d-none d-md-inline-block">
          <Nav.Link href="#pricing" className="text-lg px-lg-3">
            Cenik
          </Nav.Link>
        </Nav.Item>
        <Nav.Item className="d-none d-md-inline-block">
          <Nav.Link href="#faq" className="text-lg px-lg-3">
            Pomoč
          </Nav.Link>
        </Nav.Item>
      </Nav>
      <Button
        href="auth/sign-in"
        variant="outline-secondary"
        className="ms-2"
        size="lg"
      >
        Prijava
      </Button>
    </Container>
  </Navbar>
);

const Intro = () => (
  <section className="landing-intro landing-bg pt-5 pt-lg-6 pb-5 pb-lg-7">
    <Container className="landing-intro-content">
      <Row className="align-items-center">
        <Col lg="5" className="mx-auto">
          <h1 className="my-4">Nikoli več ne zamudite pravega oglasa</h1>

          <p className="text-lg">
            Hitro in zanesljivo obveščanje o novih oglasih za avtomobile,
            tovorna vozila in delovne stroje
          </p>

          <div className="my-4">
            <div className="d-inline-block me-3">
              <h2 className="text-dark">6350+</h2>
              <span className="text-muted">Poslanih obvestil</span>
            </div>
            <div className="d-inline-block me-3">
              <h2 className="text-dark">1000+</h2>
              <span className="text-muted">Oglasov na dan</span>
            </div>
            <div className="d-inline-block">
              <h2 className="text-dark">3</h2>
              <span className="text-muted">Kategorije oglasov</span>
            </div>
          </div>
          <div className="my-4">
            <a
              href="/auth/register/PROMOVIPCODE"
              className="btn btn-primary btn-lg me-1"
            >
              Brezplačni preizkus
            </a>
            <a href="#features" className="btn btn-outline-primary btn-lg me-2">
              Predstavitev
            </a>
          </div>
        </Col>
        <Col lg="7" className="d-none d-lg-flex mx-auto text-center">
          <div className="landing-intro-screenshot pb-3">
            <img
              src={screenshotAds}
              alt="Pregled zadnje dodanih oglasov"
              className="img-fluid"
            />
          </div>
        </Col>
      </Row>
    </Container>
  </section>
);

const Features = () => (
  <section id="features" className="py-6 bg-white">
    <Container>
      <Row>
        <Col md="10" className="mx-auto text-center">
          <div className="mb-5">
            <h2 className="h1">Predstavitev</h2>
            <p className="text-muted text-lg">
              Z mobilno aplikacijo ali namiznim računalnikom - oglasi, filtri in
              poročila vedno na voljo
            </p>
          </div>

          <Row className="text-start">
            <Col md="6">
              <div className="d-flex py-3">
                <div className="landing-feature">
                  <Smartphone />
                </div>
                <div className="flex-grow-1">
                  <h4 className="mt-0">SMS obveščanje</h4>
                  <p className="fs-lg">
                    Bodite obveščeni na mobilni telefon, v trenutku, ko je dodan
                    nov oglas.
                  </p>
                </div>
              </div>
            </Col>
            <Col md="6">
              <div className="d-flex py-3">
                <div className="landing-feature">
                  <Sliders />
                </div>
                <div className="flex-grow-1">
                  <h4 className="mt-0">Filtri</h4>
                  <p className="fs-lg">
                    Napredni filtri, za obveščanje samo o oglasih, ki vas
                    zanimajo.
                  </p>
                </div>
              </div>
            </Col>
            <Col md="6">
              <div className="d-flex py-3">
                <div className="landing-feature">
                  <PieChart />
                </div>
                <div className="flex-grow-1">
                  <h4 className="mt-0">Poročila</h4>
                  <p className="fs-lg">
                    Imejte pregled nad oglasi in cenami, ki vas zanimajo.
                  </p>
                </div>
              </div>
            </Col>
            <Col md="6">
              <div className="d-flex py-3">
                <div className="landing-feature">
                  <Users />
                </div>
                <div className="flex-grow-1">
                  <h4 className="mt-0">Več uporabnikov</h4>
                  <p className="fs-lg">
                    Odkrijte prave oglase skupaj s sodelavci.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  </section>
);

const Faq = () => {
  const [activeKey, setActiveKey] = useState("0");

  return (
    <section id="faq" className="bg-white py-6">
      <Container>
        <div className="mb-5 text-center">
          <h2 className="h1">Pogosta vprašanja</h2>
          <p className="text-muted fs-lg">
            Nekaj odgovorov na najpogostejša vprašanja
          </p>
        </div>

        <Row>
          <Col md={9} lg={8} className="mx-auto">
            <Accordion activeKey={activeKey}>
              <Card className="border mb-3">
                <Card.Header
                  className="cursor-pointer"
                  onClick={() => setActiveKey("0")}
                >
                  <h6 className="mb-0">
                    Ali je možno aplikacijo pred nakupom preizkusiti?
                  </h6>
                </Card.Header>
                <Accordion.Collapse eventKey="0">
                  <Card.Body className="py-3">
                    Da, vsak uporabnik dobi pri registraciji 1 mesec časa za
                    preizkus aplikacije. Po tem obdobju bo potrebno za
                    nadaljevanje prejemanja obvestil vnesti plačilno kartico.
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card className="border mb-3">
                <Card.Header
                  className="cursor-pointer"
                  onClick={() => setActiveKey("3")}
                >
                  <h6 className="mb-0">Kateri so možni načini plačila?</h6>
                </Card.Header>
                <Accordion.Collapse eventKey="3">
                  <Card.Body className="py-3">
                    Za plačilo lahko uporabite katero koli plačilno kartico -
                    MasterCard, Visa, American Express,...
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card className="border mb-3">
                <Card.Header
                  className="cursor-pointer"
                  onClick={() => setActiveKey("1")}
                >
                  <h6 className="mb-0">
                    Koga lahko kontaktiram v primeru dodatnih vprašanj?
                  </h6>
                </Card.Header>
                <Accordion.Collapse eventKey="1">
                  <Card.Body className="py-3">
                    Če imate še kakšno vprašanje, nam prosim pišite na{" "}
                    <a href="mailto:mail@novioglasi.com">mail@NoviOglasi.com</a>{" "}
                    in z veseljem vam bomo pomagali.
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

const Pricing = () => {
  return (
    <section id="pricing" className="py-6">
      <Container>
        <Row>
          <Col md="10" className="mx-auto text-center">
            <div className="mb-5">
              <h2 className="h1">Cenik</h2>
              <p className="text-muted text-lg">
                Na voljo so mesečni paketi za različno zahtevne uporabnike
              </p>
            </div>

            <Row className="text-start">
              {PLANS.map((plan, index: number) => {
                return (
                  <Col sm="4" className="mb-3 mb-md-0" key={"plan_" + index}>
                    <Card className="text-center h-100">
                      <Card.Body className="d-flex flex-column">
                        <div className="mb-1 p-4">
                          <h3 className="mb-4">{plan.name} paket</h3>
                          {plan.price ? (
                            <>
                              <span className="h2">{plan.price}€</span>
                              <span>/mesec</span>
                            </>
                          ) : (
                            <div className="mb-2">po dogovoru</div>
                          )}
                        </div>
                        <hr />
                        <ul className="list-unstyled mt-4">
                          {plan.features.map((feature, index: number) => {
                            return (
                              <li className="mb-2" key={"feature_" + index}>
                                {feature}
                              </li>
                            );
                          })}
                        </ul>
                        {plan.price ? (
                          <Button
                            variant="primary"
                            href="/auth/register/PROMOVIPCODE"
                            className="mt-auto"
                          >
                            Brezplačni preizkus
                          </Button>
                        ) : (
                          <Button
                            variant="outline-secondary"
                            href="mailto:mail@novioglasi.com"
                            className="mt-auto"
                          >
                            Kontaktirajte nas
                          </Button>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

const Footer = () => (
  <section className="landing-footer py-6">
    <Container className="text-center landing-footer-container">
      <Row>
        <Col md="9" lg="8" xl="6" className="mx-auto">
          <h2 className="h1 mb-5">Ne zamudite več pravega oglasa!</h2>
          <Button
            variant="primary"
            size="lg"
            href="/auth/register/PROMOVIPCODE"
            className="mt-n1"
          >
            Brezplačni preizkus
          </Button>
        </Col>
      </Row>
    </Container>
  </section>
);

const Landing = () => {
  return (
    <React.Fragment>
      <Navigation />
      <Intro />
      <Features />
      <Pricing />
      <Faq />
      <Footer />
    </React.Fragment>
  );
};

export default Landing;
